import { Link } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";

function Home() {
	return (
		<div>
			<div className="bg-gray-300 text-slate-800 p-20 text-center">
				<h1 className="text-5xl font-bold mb-4">
					Welcome to Telemix Company Limited
				</h1>
				<p className="text-xl">
					Your trusted partner in ICT, infrastructure, and power solutions.
				</p>
				<Link
					to="/services"
					className="mt-6 inline-block bg-amber-500 text-slate-900 px-6 py-3 rounded-lg font-semibold"
				>
					Explore Services
				</Link>
			</div>

			<section className="p-8">
				<h2 className="text-3xl font-bold mb-6 text-center">Our Services</h2>
				<div className="grid md:grid-cols-4 gap-6">
					<ServiceCard
						title="ICT Consulting"
						description="Professional advisory services tailored to your business needs."
						icon="💼"
					/>
					<ServiceCard
						title="IT Infrastructure Installation"
						description="Deployment of reliable and scalable IT infrastructure."
						icon="🖥️"
					/>
					<ServiceCard
						title="Power Installation"
						description="Solar, inverter, and power backup installations for businesses."
						icon="🔋"
					/>
					<ServiceCard
						title="Civil Works"
						description="Construction and structural projects with professional engineering."
						icon="🏗️"
					/>
				</div>
			</section>
		</div>
	);
}

export default Home;
